"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../shared");

var _shared2 = _interopRequireDefault(require("./shared"));

var _variants = require("./variants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Label = _styledComponents["default"].label.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "label__Label",
  componentId: "sc-1tyvjro-0"
})(["", ";", ";"], _shared2["default"], _variants.labelVariants);

var _default = Label;
exports["default"] = _default;